import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

// app: components
import Heading from 'components/Heading';
import SignupForm from 'components/SignupForm';

// app: props
import AuthProps from 'components/LoginForm/AuthProps';

// app: services
import history from 'services/history';
import assets from 'services/assets';

function Signup(props) {
  const {
    className,
    heading,
    loginPath,
    onLoginClick,
    returnTo,
    logo,
    logoAlt,
    message,
    partner,
  } = props;
  const authConfig = useSelector(state => props.authConfig || state.config.authConfig);
  const locationState = useSelector(state => state.router.locationState);

  const handleLoginClick = () => {
    if (typeof onLoginClick === 'function') {
      onLoginClick();
    } else {
      history.push(loginPath, { returnTo, ...locationState });
    }
  };
  const headingToRender =
    typeof locationState.signupHeading === 'undefined' ? heading : locationState.signupHeading;
  return (
    <div className={className}>
      {logo ? (
        <img
          src={assets.partnerUrl(logo, {
            partner,
            resize: 'fit-in',
            width: 300,
            height: 100,
          })}
          srcSet={assets.srcSet(
            logo,
            [
              { partner, w: 300, h: 100, resize: 'fit-in' },
              { partner, w: 300 * 2, h: 100 * 2, resize: 'fit-in' },
            ],
            assets.partnerUrl,
          )}
          height="100"
          className="margin-bottom-10"
          alt={logoAlt}
        />
      ) : null}
      {headingToRender && !logo ? (
        <header className="centered">
          <Heading level={1} className="heading heading--size-32">
            {headingToRender}
          </Heading>
        </header>
      ) : null}
      <SignupForm
        authParams={authConfig}
        signupMessage={message}
        {...locationState}
        returnTo={returnTo || locationState.returnTo}
      />
      <p>
        Already a member?{' '}
        <button onClick={handleLoginClick} className="link link--energized">
          Log in
        </button>
      </p>
    </div>
  );
}

Signup.propTypes = {
  authConfig: AuthProps,
  className: PropTypes.string,
  heading: PropTypes.string,
  loginPath: PropTypes.string,
  logo: PropTypes.string,
  logoAlt: PropTypes.string,
  message: PropTypes.string,
  onLoginClick: PropTypes.func,
  partner: PropTypes.string,
  returnTo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

Signup.defaultProps = {
  authConfig: null,
  className: '',
  heading: 'Join ckbk',
  loginPath: '/login',
  logo: null,
  logoAlt: null,
  message: null,
  onLoginClick: null,
  partner: null,
  returnTo: null,
};

export default Signup;
